(() => {
  if (window.aqsaInstallLoaded) return;
  window.aqsaInstallLoaded = true;

  let installPrompt = null;
  let box;
  let installed = false;

  const standalone = () =>
    installed ||
    window.matchMedia('(display-mode: standalone)').matches ||
    navigator.standalone === true;

  window.addEventListener('beforeinstallprompt', (event) => {
    if (standalone()) return;
    event.preventDefault();
    installPrompt = event;
  });

  window.addEventListener('appinstalled', () => {
    installed = true;
    installPrompt = null;
    if (box) box.remove();
  });

  function setup() {
    if (standalone()) return;

    const arabic = document.documentElement.lang.startsWith('ar');
    const iphone =
      /iPhone|iPad|iPod/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    box = document.createElement('div');
    const root = box.attachShadow({ mode: 'open' });

    root.innerHTML = `
      <style>
        section {
          padding: 24px 16px;
          text-align: center;
          background: #f4f6f2;
          color: #143d2b;
          font: 16px/1.6 system-ui, sans-serif;
        }
        h2 { margin: 0 0 12px; font-size: 22px; }
        button {
          background: #143d2b;
          color: white;
          border: 0;
          border-radius: 10px;
          padding: 12px 24px;
          font: inherit;
          cursor: pointer;
        }
        button:focus-visible {
          outline: 3px solid #ac7e18;
          outline-offset: 4px;
        }
        p { max-width: 550px; margin: 14px auto 0; }
      </style>
      <section dir="${arabic ? 'rtl' : 'ltr'}">
        <h2>${arabic ? 'الأقصى على موبايلك' : 'AQSA on your home screen'}</h2>
        <button type="button">
          ${arabic ? 'إضافة الأقصى للموبايل' : 'Add AQSA to your phone'}
        </button>
        <p role="status" hidden></p>
      </section>
    `;

    const button = root.querySelector('button');
    const message = root.querySelector('p');

    function showHelp() {
      message.hidden = false;
      message.textContent = iphone
        ? (arabic
          ? 'افتح الموقع في Safari، اضغط مشاركة، ثم إضافة إلى الشاشة الرئيسية.'
          : 'Open in Safari, tap Share, then Add to Home Screen.')
        : (arabic
          ? 'افتح الموقع في Chrome، ومن قائمة ⋮ اختر تثبيت التطبيق أو إضافة إلى الشاشة الرئيسية إذا ظهر الخيار.'
          : 'Open in Chrome. From the browser menu, choose Install app or Add to Home screen if available.');
    }

    button.addEventListener('click', async () => {
      if (!installPrompt) {
        showHelp();
        return;
      }

      const prompt = installPrompt;
      installPrompt = null;
      button.disabled = true;

      try {
        await prompt.prompt();
        const choice = await prompt.userChoice;
        if (choice.outcome === 'accepted') box.remove();
      } catch {
        showHelp();
      } finally {
        button.disabled = false;
      }
    });

    const footer = document.querySelector('footer');
    if (footer) footer.before(box);
    else document.body.append(box);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup, { once: true });
  } else {
    setup();
  }
})();